import React, { useEffect, useState, useRef } from "react";
import styles from "../CommentBox/style.module.css";

function Textfeild({
  initialData,
  onValueChange,
  invalid = false,
  liningColour = "",
  locked = false,
  placeholder = "",
}) {
  const [comment, setComment] = useState(initialData || "");
  const [isInvalid, setIsInvalid] = useState(invalid);
  const [isFocused, setIsFocused] = useState(false);
  const [color, setColor] = useState(liningColour);
  const commentRef = useRef(null);

  const handleTextChange = (e) => {
    setIsInvalid(false);
    setComment(e.target.value);

    if (onValueChange) {
      onValueChange(e.target.value);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    if (comment === "") {
      setIsFocused(false);
    }
  };

  useEffect(() => {
    setIsInvalid(invalid);
  }, [invalid]);

  const commentClass = `${styles.Comment} ${
    invalid ? styles.invalidInput : ""
  }`;

  return (
    <input
      ref={commentRef}
      type="text"
      inputMode="text"
      className={`${styles.Comment}  ${
        isInvalid ? styles.invalidInputTextfeild : ""
      }`}
      id="FormComment"
      placeholder={placeholder}
      readOnly={locked}
      value={comment}
      onChange={handleTextChange}
      style={{ borderColor: liningColour, height: "25px" }}
    />
  );
}

export default Textfeild;
